import { render, staticRenderFns } from "./TreatmentRecord.vue?vue&type=template&id=7d28d5b3&scoped=true"
import script from "./TreatmentRecord.vue?vue&type=script&lang=js"
export * from "./TreatmentRecord.vue?vue&type=script&lang=js"
import style0 from "./TreatmentRecord.vue?vue&type=style&index=0&id=7d28d5b3&lang=css"
import style1 from "./TreatmentRecord.vue?vue&type=style&index=1&id=7d28d5b3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d28d5b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d28d5b3')) {
      api.createRecord('7d28d5b3', component.options)
    } else {
      api.reload('7d28d5b3', component.options)
    }
    module.hot.accept("./TreatmentRecord.vue?vue&type=template&id=7d28d5b3&scoped=true", function () {
      api.rerender('7d28d5b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/diagnosisRecord/TreatmentRecord.vue"
export default component.exports